import Head from 'next/head';
import React from 'react';

import { IMarketingPage } from '@/services/getMarketingPage';

interface IProps {
  page: IMarketingPage;
}

/**
 * Generic Sanity-backed marketing page renderer. Used by the small set of
 * static pages that used to be served by nginx → WordPress proxy
 * (`/coachnet-renters`, `/owner-survey-decide-approve-renters`).
 *
 * Inherits the global header/footer from `ApplicationLayout` via `_app.tsx`.
 * Body is rendered raw — the imported HTML carries its own `<style>` block
 * and `.w-container` / `.cn-header-container` classes which handle layout
 * and centering, so we do not wrap it in `prose` or `MaxWidth` (both
 * fight the theme CSS specificity). `featuredImage` and `<h1>` are also
 * left to the inline HTML, which already includes them.
 */
const MarketingPage: React.FC<IProps> = ({ page }) => {
  return (
    <>
      <Head>
        <title>{page.seoTitle ?? page.title}</title>
        {page.seoDescription && <meta name="description" content={page.seoDescription} />}
        <link rel="canonical" href={`https://www.outdoorsy.com/${page.slug}`} />
      </Head>
      <div dangerouslySetInnerHTML={{ __html: page.contentHtml }} />
    </>
  );
};

export default MarketingPage;
